import { useMemo, useState } from 'react';

import classNames from 'classnames';

import type { Recommendation } from '@/types';

import { EmailModal } from './EmailModal';

interface SubscribeButtonProps {
  recommendation: Recommendation;
  isLoading?: boolean;
  email?: string;
  submittedIds: string[];
  translations?: Record<string, string>;
  variant?: 'solid' | 'outline';
}

export const SubscribeButton: React.FC<SubscribeButtonProps> = ({
  email,
  recommendation,
  submittedIds,
  isLoading,
  translations,
  variant = 'outline',
}) => {
  const hasSubscribed = useMemo(() => submittedIds.includes(recommendation.id), [submittedIds, recommendation.id]);
  const [emailCaptureOpen, setEmailCaptureOpen] = useState(false);

  return (
    <div className="relative">
      <button
        type={email ? 'submit' : 'button'}
        onClick={(e) => {
          if (!email) {
            e.preventDefault();
            setEmailCaptureOpen(true);
          }
        }}
        className={classNames(
          'px-2 py-1 rounded-[var(--site-theme-border-radius,6px)] border border-[var(--site-theme-primary-color,#030712)] font-medium flex gap-2 items-center',
          variant === 'solid'
            ? 'bg-[var(--site-theme-primary-color,#030712)] text-[var(--site-theme-background-color,#ffffff)]'
            : 'bg-[var(--site-theme-background-color,#ffffff)] text-[var(--site-theme-primary-color,#030712)]',
          hasSubscribed ? 'opacity-30 cursor-not-allowed' : 'hover:opacity-80',
          isLoading && 'cursor-wait',
        )}
        style={{ fontFamily: 'var(--site-theme-button-font)' }}
        disabled={hasSubscribed || isLoading}
      >
        {hasSubscribed
          ? translations?.['recommendations.modal.subscribed'] || 'Subscribed'
          : isLoading
            ? translations?.['recommendations.modal.subscribing'] || 'Subscribing...'
            : translations?.['recommendations.modal.subscribe'] || 'Subscribe'}
      </button>
      <EmailModal
        isOpen={emailCaptureOpen}
        onClose={() => setEmailCaptureOpen(false)}
        className="w-72 -top-3 -right-2"
      />
    </div>
  );
};
